function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M46.34 10.62h-6c-4.73 0-5.61 2.26-5.61 5.53v7.27H46l-1.5 11.39h-9.81V64H22.92V34.81h-9.81V23.42h9.81V15c0-9.73 6-15 14.65-15a76.53 76.53 0 018.77.46z"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iZjRiOGM3OTgtMzkyOS00ZjU0LThkYzctMWYyNWRlZDcxYWFkIiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZmFjZWJvb2s8L3RpdGxlPjxwYXRoIGQ9Ik00Ni4zNCwxMC42MmgtNmMtNC43MywwLTUuNjEsMi4yNi01LjYxLDUuNTN2Ny4yN0g0NmwtMS41LDExLjM5SDM0LjY5VjY0SDIyLjkyVjM0LjgxSDEzLjExVjIzLjQyaDkuODFWMTVjMC05LjczLDYtMTUsMTQuNjUtMTVhNzYuNTMsNzYuNTMsMCwwLDEsOC43Ny40NloiLz48L3N2Zz4=";
export { SvgFacebook as ReactComponent };